import { C as CosmosMediaPreview$1, d as defineCustomElement$1 } from './p-D3hOnF9z.js';

const CosmosMediaPreview = CosmosMediaPreview$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosMediaPreview, defineCustomElement };
